import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { extractError } from "../../lib/format";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";

export default function AdminContent() {
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    let alive = true;
    api.get("/admin/content-status")
      .then(({ data }) => alive && setState({ loading: false, data, error: null }))
      .catch((e) => alive && setState({ loading: false, data: null, error: extractError(e, "Could not load content status.") }));
    return () => { alive = false; };
  }, []);

  if (state.loading) return <div className="ftg-adm__empty" data-testid="content-loading"><Loader2 className="ftg-spin" size={16} /> Loading…</div>;
  if (state.error) return <div className="ftg-adm__empty">{state.error}</div>;
  const d = state.data;

  return (
    <div className="ftg-adm__stack" data-testid="content-root">
      <div className="ftg-adm__stat-grid">
        <div className="ftg-adm__stat" data-testid="content-stat-indexed">
          <div className="ftg-adm__stat-label">Lessons indexed</div>
          <div className="ftg-adm__stat-value">{d.lessons_indexed}</div>
        </div>
        <div className="ftg-adm__stat" data-testid="content-stat-audio">
          <div className="ftg-adm__stat-label">Lessons with audio</div>
          <div className="ftg-adm__stat-value">{d.lessons_with_audio}</div>
        </div>
        <div className="ftg-adm__stat" data-testid="content-stat-md">
          <div className="ftg-adm__stat-label">Markdown files on disk</div>
          <div className="ftg-adm__stat-value">{d.markdown_files_on_disk}</div>
        </div>
        <div className="ftg-adm__stat" data-testid="content-stat-mp3">
          <div className="ftg-adm__stat-label">MP3 files on disk</div>
          <div className="ftg-adm__stat-value">{d.audio_files_on_disk}</div>
        </div>
        <div className="ftg-adm__stat" data-testid="content-stat-workbooks">
          <div className="ftg-adm__stat-label">Workbook PDFs</div>
          <div className="ftg-adm__stat-value">{d.workbook_pdfs}</div>
        </div>
        <div className="ftg-adm__stat" data-testid="content-stat-illustrations">
          <div className="ftg-adm__stat-label">Illustrations</div>
          <div className="ftg-adm__stat-value">{d.illustrations}</div>
        </div>
      </div>

      <section>
        <h3 className="ftg-adm__section-title">Sanity checks</h3>
        <div className="ftg-adm__checks" data-testid="content-checks">
          {d.checks.map((c) => (
            <div key={c.name} className={`ftg-adm__check${c.ok ? " is-ok" : " is-fail"}`} data-testid={`content-check-${c.name.replace(/\s+/g, '-').toLowerCase()}`}>
              {c.ok ? <CheckCircle2 size={16} /> : <AlertCircle size={16} />}
              <div>
                <div className="ftg-adm__check-name">{c.name}</div>
                <div className="ftg-adm__check-val">{c.value} / target {c.target}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
